import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { studentLifeContent } from '../data/content';

const StudentLifePage = () => {
  return (
    <div data-testid="student-life-page" className="bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
          <div className="absolute top-20 left-20 w-72 h-72 bg-coral/10 rounded-full blur-3xl" />
          <div className="section-container relative z-10">
            <span className="inline-block px-4 py-2 bg-coral/10 text-coral rounded-full text-sm font-semibold mb-4">
              Life at Apollo House
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 font-['Outfit'] mb-6">
              {studentLifeContent.title.replace('Apollo House', '')} <span className="text-coral">Apollo House</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl">
              {studentLifeContent.intro}
            </p>
          </div>
        </section>

        {/* Sections */}
        {studentLifeContent.sections.map((section, idx) => (
          <section
            key={idx}
            data-testid={`student-life-section-${idx}`}
            className={`section-spacing ${idx % 2 === 0 ? 'bg-white' : 'bg-orange-50'} relative overflow-hidden`}
          >
            <div className="absolute top-10 right-10 w-64 h-64 bg-coral/5 rounded-full blur-3xl" />
            <div className="section-container relative z-10">
              <div className={`grid lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={idx % 2 === 1 ? 'lg:order-2' : ''}>
                  <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                    {section.title}
                  </h2>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    {section.description}
                  </p>
                </div>
                <div className={`rounded-2xl overflow-hidden shadow-xl border border-orange-100 ${idx % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <img
                    src={section.image}
                    alt={section.title}
                    className="w-full h-80 object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>
        ))}

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default StudentLifePage;
